import { LT_FEATURE_FLAG_UPDATE } from '../constants/featureFlag';

import { FeatureFlag } from 'constants/feature-flags';

const initialState = {
  isLoading: true,
};

function featureFlag(state = initialState, actions) {
  const { type, payload, extra = {} } = actions;
  switch (type) {
    case LT_FEATURE_FLAG_UPDATE:
      const flags = payload?.data || [];

      const userId = extra?.userId;
      const featureFlags = { ...FeatureFlag };
      Object.keys(featureFlags).forEach((key) => {
        featureFlags[key] = flags.includes(featureFlags[key]);
      });
      localStorage.setItem(
        `featureFlags${userId}`,
        JSON.stringify(featureFlags)
      );
      return {
        ...state,
        isLoading: false,
        ...featureFlags,
      };
    default:
      return state;
  }
}

export default featureFlag;
